import React, { useEffect, useState } from "react";
import { ChevronDown, ChevronRight, MapPin, CheckCircle2, XCircle } from "lucide-react";
import { api } from "@/contexts/AuthContext";

// Collapsible list of past planned-stop notes for a dealer (visited / skipped).
export function VisitHistory({ dealerId, defaultOpen = false, compact = false }) {
  const [open, setOpen] = useState(defaultOpen);
  const [rows, setRows] = useState(null);
  useEffect(() => { if (open && rows === null) api.get(`/calendar/visits/dealer/${dealerId}`).then(({ data }) => setRows(data)).catch(() => setRows([])); }, [open, dealerId, rows]);
  return (
    <div className={compact ? "" : "border border-[#E9ECEF] rounded-sm bg-white"} data-testid="visit-history">
      <button type="button" onClick={() => setOpen(!open)} className={`w-full flex items-center gap-2 text-left ${compact ? "text-[10px] uppercase tracking-[0.2em] font-bold text-[#0B132B] py-1" : "px-4 py-3 text-xs uppercase tracking-[0.2em] font-bold text-[#0B132B]"}`} data-testid="visit-history-toggle">
        {open ? <ChevronDown size={14} /> : <ChevronRight size={14} />}<MapPin size={12} className="text-[#D4AF37]" /> Stop-in history{rows ? <span className="text-[#6C757D] font-normal normal-case tracking-normal">({rows.length})</span> : null}
      </button>
      {open && (
        <div className={compact ? "mt-1" : "px-4 pb-4"}>
          {rows === null ? <div className="text-xs text-[#6C757D]">Loading…</div> : rows.length === 0 ? <div className="text-xs italic text-[#6C757D]" data-testid="visit-history-empty">No stop-ins logged for this dealer yet.</div> : (
            <ul className="divide-y divide-[#F1F3F5]" data-testid="visit-history-list">
              {rows.map((r, i) => (
                <li key={i} className="py-2 text-xs flex gap-2" data-testid={`visit-history-row-${i}`}>
                  {r.status === "visited" ? <CheckCircle2 size={13} className="text-emerald-600 mt-0.5 shrink-0" /> : <XCircle size={13} className="text-red-600 mt-0.5 shrink-0" />}
                  <div className="min-w-0">
                    <div className="text-[#0B132B]"><b>{new Date(r.date + "T12:00:00").toLocaleDateString()}</b> · {r.by_name}{r.status === "visited" ? (r.spoke_with ? <> · spoke with <b>{r.spoke_with}</b></> : null) : <span className="text-red-700"> · didn't stop in</span>}</div>
                    {r.status === "visited" ? <div className="text-[#6C757D]">{r.summary}{r.next_steps && <> · <b>Next:</b> {r.next_steps}</>}</div> : <div className="text-[#6C757D]">Reason: {r.reason}</div>}
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
}
